// extracted by mini-css-extract-plugin
export var notificationHost = "_ld-0";